import { IconButton, Menu, MenuItem } from "@mui/material"
import { useRef, useState } from "react"
import { prevent } from "lib/prevent"
import noop from "lib/noop"
import { EditField, TaskListRefresh } from "event-definitions"
import { generate } from "library/guid/index.mjs"
import { IsEditMode } from "lib/@components/edit-mode"
import { indexTasksInSchedule } from "routes/schedule/lib/index-tasks-in-schedule"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { createAudit } from "lib/@offline/queued-audits"
import { PAYLOAD_STATUS_TASK_ADDED } from "routes/audit/lib/audit-constants"
import { defaultNewHeader, defaultNewTask } from "../lib/default-tasks"
export function AddTaskButton() {
    const { schedule, task, referenceId, draftId } = useBoundContext()
    const [anchor, setAnchor] = useState(null)
    const buttonRef = useRef()
    return (
        <IsEditMode>
            <IconButton
                aria-label="Add task"
                className="add-task"
                data-cy="add-task"
                ref={buttonRef}
                color="primary"
                size="small"
                onClick={prevent(() => setAnchor(buttonRef.current))}
            >
                <Iconify icon="mdi:add" />
            </IconButton>

            <Menu onClick={prevent(noop)} open={!!anchor} anchorEl={anchor} onClose={() => setAnchor(null)}>
                <MenuItem onClick={addTask} data-cy="add-task-add-task">
                    Add Task
                </MenuItem>
                <MenuItem onClick={addHeader} data-cy="add-task-add-header">
                    Add Header
                </MenuItem>
            </Menu>
        </IsEditMode>
    )

    async function addTask() {
        const newTask = defaultNewTask()
        newTask.id = generate()
        if (task) {
            schedule.tasks.splice(task.$sort + 1, 0, newTask)
        } else {
            schedule.tasks.push(newTask)
        }
        indexTasksInSchedule(schedule)
        try {
            await createAudit("", "", "customSchedule", referenceId, {
                changeType: "task",
                idForDraft: draftId,
                taskId: newTask.taskId,
                taskTitle: newTask.title,
                isHeader: false,
                status: PAYLOAD_STATUS_TASK_ADDED,
                event: "tailoring!custom-schedule-new-task",
                subHeader: "added to schedule",
            })
        } catch (e) {
            console.warn("Audit creation failed (offline or network error):", e?.message || e)
        }
        TaskListRefresh.raise()
        setAnchor(null)
        EditField.raiseLater({ target: newTask, field: "title" })
    }

    async function addHeader() {
        const newTask = defaultNewHeader()
        newTask.id = generate()
        if (task) {
            schedule.tasks.splice(task.$sort + 1, 0, newTask)
        } else {
            schedule.tasks.push(newTask)
        }
        indexTasksInSchedule(schedule)
        try {
            await createAudit("", "", "customSchedule", referenceId, {
                changeType: "task",
                idForDraft: draftId,
                taskId: newTask.taskId,
                taskTitle: newTask.title,
                isHeader: true,
                status: PAYLOAD_STATUS_TASK_ADDED,
                event: "tailoring!custom-schedule-new-task",
                subHeader: "added to schedule",
            })
        } catch (e) {
            console.warn("Audit creation failed (offline or network error):", e?.message || e)
        }
        TaskListRefresh.raise()
        setAnchor(null)
        EditField.raiseLater({ target: newTask, field: "title" })
    }
}
